export default {
    props: {
        sortableAllowUnsort: {
            type: Boolean,
            kComposite: 'sortable.allowUnsort'
        }, 
        sortableShowIndexes: {
            type: Boolean,
            kComposite: 'sortable.showIndexes'
        }, 
        sortableInitialDirection: {
            type: String,
            kComposite: 'sortable.initialDirection'
        }, 
        sortableMode: {
            type: String,
            kComposite: 'sortable.mode'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-grid-vue-wrapper/src/KendoGrid/Sortable.js